import { render, staticRenderFns } from "./AttributeValueDialog.vue?vue&type=template&id=7a7f1907"
import script from "./AttributeValueDialog.vue?vue&type=script&lang=js"
export * from "./AttributeValueDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports